import React, { useState } from 'react';
import { X } from 'lucide-react';

export default function TagsInput({ tags = [], onChange, placeholder = 'Add tag...' }) {
  const [input, setInput] = useState('');
  
  const addTag = (val) => {
    const t = val.trim().toLowerCase();
    if (t && !tags.includes(t)) {
      onChange([...tags, t]);
    }
    setInput('');
  };

  const removeTag = (idx) => {
    onChange(tags.filter((_, i) => i !== idx));
  };

  return (
    <div className="tags-input" onClick={e => e.currentTarget.querySelector('input')?.focus()}>
      {tags.map((t, i) => (
        <span className="tag" key={i}>
          {t} <X size={10} className="tag-rm" onClick={() => removeTag(i)} />
        </span>
      ))}
      <input
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); addTag(input); }
          if (e.key === 'Backspace' && !input && tags.length) removeTag(tags.length - 1);
        }}
        onBlur={() => { if (input) addTag(input); }}
        placeholder={tags.length ? '' : placeholder}
      />
    </div>
  );
}
